

import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";

import Grid from "@mui/joy/Grid";
import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import Button from "@mui/joy/Button";



import useServiceWorker from "hooks/useServiceWorker";


import useUserIdentity from "hooks/useUserIdentity";
import ClaimedWorkList from "components/ClaimedWorkList";
import AssistantOnly from "components/AssistantOnly";
import CombinedRequestAndCollabList from 'components/CombinedRequestAndCollabList'


import getIcon from 'utils/getIcon';
import FancyIcon from "./FancyIcon";


// const DedicatedAssistantExplainer = observer(() => {
//     return (
//         <Stack>
//             <Typography
//                 fontSize={{ xs: 'md', md: 'lg' }}
//                 fontWeight="lg"
//                 sx={{ mr: 'auto' }}
//             >
//                 Your Dedicated Team
//             </Typography>
//             <Typography
//                 level="body-sm"
//                 sx={{ mr: 'auto' }}
//             >
//                 If you had a dedicated assistant, your team would show up here.
//             </Typography>

//         </Stack>
//     );
// });

const NotificationsSetting = observer(() => {
    const { isSubscribed, askForPermission, unsupported } = useServiceWorker();
    const NotificationsIcon = getIcon('Notifications');

    if (isSubscribed())
        return null;

    if (unsupported)
        return null;

    // if(unsupported)
    //     return (
    //         <Chip
    //             sx={{ cursor: "default" }}
    //             color="danger"
    //             startDecorator={<NotificationsIcon />}
    //         >Notifications not supported</Chip>
    //     );

    return (
        <Stack alignItems="center">

            <Typography
                startDecorator={<NotificationsIcon />}
                level="body-xs">Get notifications when you're away</Typography>
            <Stack alignItems="center" direction="row">

                <Button
                    size="sm"
                    variant="plain"
                    color="success"
                    onClick={() => askForPermission()}>
                    Enable Notifications
                </Button>
            </Stack>
        </Stack>
    );
});

const HomeAssistant = observer(() => {
    const { currentIdentity } = useUserIdentity();
    const navigate = useNavigate();

    return (
        <AssistantOnly allowIC={true}>
        <Stack spacing={3}>

            <Grid container
                direction={{ xs: "column-reverse", sm: "row" }}>
                <Grid xs={12} sm={7} >
                    <ClaimedWorkList paged={true} status="active" />
                </Grid>
                <Grid xs={12} sm={5} >
                    <AssistantOnly>
                    {currentIdentity.dedicated &&

                        <Stack
                            sx={{ width: '100%' }}
                            direction="row"
                            alignItems="center"
                            justifyContent="space-between"
                            borderBottom={1}
                            borderColor="divider"
                            spacing={1}
                            pb={1}
                            m={1}

                        >

                            <Button
                                startDecorator={<FancyIcon name="DayOnesDedicated" />}
                                variant="outlined"
                                onClick={() => navigate(`/dedicated?assistant=${currentIdentity.uuid}`)}
                                fullWidth>Your Dedicated Clients
                            </Button>


                        </Stack>

                    }


                    <NotificationsSetting />
                    </AssistantOnly>

                </Grid>
            </Grid>

            <AssistantOnly>
                <CombinedRequestAndCollabList paged={true} />
            </AssistantOnly>

        </Stack>
        </AssistantOnly>

    );

});

export default HomeAssistant;
